<template>
  <div>
    <v-text-field
      v-if="inputComponent === 'v-text-field'"
      v-model="computedValue"
      dense
      :type="schema.type"
      :suffix="schema.unit"
    ></v-text-field>
    <v-switch
      v-if="inputComponent === 'v-switch'"
      v-model="computedValue"
      dense
      class="mt-0"
    ></v-switch>
  </div>
</template>

<script>
export default {
  name: "InputFromSchema",
  components: {},
  mixins: [],
  props: {
    value: { required: true },
    schema: { type: Object, required: false, default: () => {} },
  },
  data() {
    return {};
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
        this.$emit("change");
      },
    },
    inputComponent() {
      let componentName = "v-text-field";
      const { type } = this.schema;
      if (type === "boolean") {
        componentName = "v-switch";
      }
      return componentName;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
